import { PdfPageWrapper } from "../../../forms/pdf-components/PdfPageWrapper";
import { PdfPatientHeaderRow } from "./sections/PdfPatientHeaderRow";
import { PdfLabInformation } from "./sections/PdfLabInformation";
import { PdfPrescriberSuggestions } from "./sections/PdfPrescriberSuggestions";
import { PdfPrescribingPharmacistInfo } from "./sections/PdfPrescribingPharmacistInfo";

/**
 * PdfPage2
 *
 * Sections:
 *   1. Compact Patient Name + Health Card row
 *   2. Lab Information
 *   3. Prescriber Suggestions (complex 2-col form)
 *   4. Pharmacist Name + License Number
 */
export const PdfPage2 = ({
  pharmacyProps,
  serviceDate,
  patient,
  pharmacistFollowUp,
  prescriberFollowUp,
  pharmacistName,
  pharmacistLicenseNumber,
}) => {
  const {
    prescriberSuggestions = [],
    pharmacistSuggestions: pharmacistRxChangeComments = "",
    suggestFollowUp,
  } = prescriberFollowUp || {};
  const suggestFollowUpAppointment =
    suggestFollowUp === true || suggestFollowUp === "true";

  return (
    <PdfPageWrapper pharmacyProps={pharmacyProps}>
      <PdfPatientHeaderRow patient={patient} />

      <PdfLabInformation pharmacistFollowUp={pharmacistFollowUp} />

      <PdfPrescriberSuggestions
        prescriberSuggestions={prescriberSuggestions}
        pharmacistRxChangeComments={pharmacistRxChangeComments}
        suggestFollowUpAppointment={suggestFollowUpAppointment}
        pharmacistName={pharmacistName}
      />

      <PdfPrescribingPharmacistInfo
        pharmacistName={pharmacistName}
        pharmacistLicenseNumber={pharmacistLicenseNumber}
        serviceDate={serviceDate}
      />
    </PdfPageWrapper>
  );
};
